import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSparkle3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSparkle3"><Path d="M12.95 2.5H11.05L8.675 8.675L2.5 11.05V12.95L8.675 15.325L11.05 21.5H12.95L15.325 15.325L21.5 12.95V11.05L15.325 8.675L12.95 2.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconSparkle3;
